<template>
  <base-layout>
    <template #breadcrumbs>
      <ui-breadcrumbs title="Общий отчет"/>
    </template>
    <div width="100%">
      <el-select v-model="place" class="col-sm-12" placeholder="Select" size="large">
        <el-option
          v-for="(item, index ) in places"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
    </div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleTabClick">
      <el-tab-pane label="Общая информация" name="General">
        <p style="font-size: x-large">{{ place }}</p>
        <div class="d-flex justify-content-between">
          <div class="d-flex col-sm-4" style="background-color: white; margin-right: 30px">
            <div class="d-flex flex-column m-3">
              <div class="d-flex flex-column" style="font-size: 22px; font-weight: bold">'14/02/22'</div>
              <div>Начало работы</div>
            </div>
            <div class="d-flex flex-column m-3">
              <div class="d-flex flex-column" style="font-size: 22px; font-weight: bold">'14/03/22'</div>
              <div>Конец работы</div>
            </div>
          </div>
          <div class="d-flex mr-3 col-sm-4" style="background-color: white; margin-right: 30px">
            <div class="d-flex flex-column m-3">
              <div class="d-flex flex-column" style="font-size: 22px; font-weight: bold">120</div>
              <div>Количество<br>объектам</div>
            </div>
            <div class="d-flex flex-column m-3">
              <div class="d-flex flex-column" style="font-size: 22px; font-weight: bold">11</div>
              <div>Количество<br>горизонтов</div>
            </div>
          </div>
          <div class="d-flex col-sm-4" style="background-color: white">
            <div class="d-flex flex-column m-3">
              <div class="d-flex flex-column" style="font-size: 22px; font-weight: bold">3</div>
              <div>Количество<br>доб.скважин</div>
            </div>
            <div class="d-flex flex-column m-3">
              <div class="d-flex flex-column" style="font-size: 22px; font-weight: bold">2</div>
              <div>Количество<br>нагн.скважин</div>
            </div>
          </div>
        </div>
        <div class="d-flex col-sm-12  flex-column" style="background-color: white; margin-top: 30px">
          <div class="d-flex my-1" style="font-size: 18px; font-weight: bold">Описание</div>
          <div><p>Соображения высшего порядка, а также постоянный количественный рост и сфера нашей активности создаёт
            предпосылки качественно новых шагов для дальнейших направлений развитая системы массового участия. С другой
            стороны дальнейшее развитие различных форм деятельности требует от нас анализа экономической
            целесообразности принимаемых решений. Практический опыт показывает, что рамки и место обучения кадров
            позволяет выполнить важнейшие задания по разработке соответствующих условий активизации.</p></div>
        </div>
        <div class="d-flex col-sm-12  flex-column" style="background-color: white; margin-top: 30px">
          <div class="d-flex my-2" style="font-size: 18px; font-weight: bold">Google maps</div>
          <div><img v-bind:src="'../images/Map.png'"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Запросы" name="Queries">
        <el-tabs v-model="activeQueriesName" name="QueriesTabs">
          <el-tab-pane label="Фонд" name="Fond">
            <report-side-bar :indicators="places" :objects="objects" :places="places" />
          </el-tab-pane>
          <el-tab-pane label="Дебеты" name="Debits">
            <report-side-bar-dates :indicators="places" :objects="objects" :places="places" />
          </el-tab-pane>
          <el-tab-pane label="Накопленные показатели" name="Accumulated">

          </el-tab-pane>
          <el-tab-pane label="Анализ" name="Analysis">

          </el-tab-pane>
          <el-tab-pane label="Запасы" name="Reserves">

          </el-tab-pane>
          <el-tab-pane label="Давления" name="Pressure">

          </el-tab-pane>
          <el-tab-pane label="Вовлеченные запасы" name="Involved reserves">

          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="Работа с картами" name="Maps">

      </el-tab-pane>
    </el-tabs>


  </base-layout>
</template>

<script>

  import BaseLayout from '@/Layouts/BaseLayout';
  import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
  import ReportSideBar from '@modules/Reports/Resources/Pages/ReportSideBar';
  import ReportSideBarDates from '@modules/Reports/Resources/Pages/ReportSideBarDates';

  export default {
    name: "ReportGeneral",
    components: {
      ReportSideBar,
      UiBreadcrumbs,
      BaseLayout,
      ReportSideBarDates,
    },
    props: {
      places: {type: Array},
      objects: {type: Array},
      indicators: {type: Array},
      errors: {type: Object},
    },
    data() {
      return {
        place: '',

        activeName: 'Queries',
        activeQueriesName: 'Fond'
      };
    },
    methods: {
      handleTabClick() {
        //console.log(this.errors);
      }
    },
    computed: {}
  }

</script>

<style scoped>

</style>
